import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TuiTableModule } from "@taiga-ui/addon-table";
import { TuiLetModule } from "@taiga-ui/cdk";
import { TuiButtonModule, TuiFormatNumberPipeModule } from "@taiga-ui/core";
import { KwikUITableComponent } from "./table.component";

@NgModule({
  declarations: [KwikUITableComponent],
  imports: [
    CommonModule,
    TuiTableModule,
    TuiFormatNumberPipeModule,
    TuiLetModule,
    TuiButtonModule
  ],
  exports: [KwikUITableComponent]
})
export class KwikUITableModule {}
